import { declareFilter } from './vueRegister.mjs'
import { angularInvoke } from './vvuejs.parcel.mjs';

export const camelToKebab = str => str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
export const kebabToCamel = str => str.replace(/-([a-z])/g, (a, b) => b.toUpperCase());

export const camelToSnake = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
export const camelToVue = str => str.replace(/^([a-z])/g, letter => `${letter.toUpperCase()}`);

declareFilter('vform17ActionFilter', function (component, withAction) {
    if (!component) {
        return {};
    }
    var result = {};
    for (var key in component) {

        if (component[key].component && component[key].component['#type'].indexOf('vform17:action') >= 0) {
            // found 'vform17:action'
            if (withAction) {
                result[key] = component[key];
            }
        }
        else {
            // not found
            if (!withAction) {
                result[key] = component[key];
            }
        }
    }
    return result;
});

declareFilter('byWeight', function (object) {
    return Object.values(object).sort(function (a, b) {
        return parseInt(a.weight) - parseInt(b.weight);
    })
})
